import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { ComboboxOption, ComboboxLabel } from '@anyui/core';
import { TextCutter } from '../../TextCutter';
import { CheckBox, CheckBoxProps } from '../../CheckBox';
import { useMultipleSelectContext } from '../select-context';

export interface SelectAllOptionProps extends Pick<CheckBoxProps, 'checked' | 'indeterminate'> {
  label?: string;
  className?: string;
  alwaysShow?: boolean;
  rightSection?: React.ReactNode;
}

export const SelectAllOption = ({
  label,
  className,
  alwaysShow,
  rightSection,
  ...checkboxProps
}: SelectAllOptionProps) => {
  const { t } = useTranslation();
  const {
    selectAllValue,
    selectProps: { limit, loading, multiple, options, classNames, hasSelectAll = true, selectAllProps }
  } = useMultipleSelectContext();

  // Must be ??: when context is not provided, we use props otherwise use context
  const isAlwaysShow = selectAllProps?.alwaysShow ?? alwaysShow;
  const isAvailable = options?.length && !loading && limit === undefined;

  return multiple && // Only support multiple select
    hasSelectAll &&
    (isAlwaysShow || isAvailable) ? (
    <ComboboxOption value={selectAllValue} className={cn(className, classNames?.option)} forceMount>
      <CheckBox disabled={loading || !options?.length} {...checkboxProps} />
      <ComboboxLabel className={classNames?.label}>
        <TextCutter text={(selectAllProps?.label ?? label) || t('Select all')} lines={1} />
      </ComboboxLabel>
      {selectAllProps?.rightSection ?? rightSection}
    </ComboboxOption>
  ) : null;
};
